import { render, staticRenderFns } from "./todayStudy.vue?vue&type=template&id=ca68028a&scoped=true"
import script from "./todayStudy.vue?vue&type=script&lang=js"
export * from "./todayStudy.vue?vue&type=script&lang=js"
import style0 from "./todayStudy.vue?vue&type=style&index=0&id=ca68028a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca68028a",
  null
  
)

export default component.exports